
import { useQuery } from '../../_snowpack/pkg/@vue/apollo-composable.js';
import { LAUNCH_DETAILS } from '../graphql/queries.js';

const defaultExport = {
  props: {
    id: {
      type: String,
      default: '0'
    }
  },
  setup(props) {
    const { result, loading, error } = useQuery(LAUNCH_DETAILS, {
      id: props.id
    });

    return { result, loading, error };
  },
  methods: {
    toMissions() {
      this.$router.go(-1);
    },
    convertDate(dateString) {
      const dt = new Date(dateString);
      return dt.toLocaleString();
    }
  }
};

import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "../../_snowpack/pkg/vue.js"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "text-center display-6 text-muted"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "fw-bold text-center m-lg-5 m-3" }
const _hoisted_5 = { class: "d-flex flex-column align-items-center" }
const _hoisted_6 = ["id", "src"]
const _hoisted_7 = ["id", "src"]
const _hoisted_8 = { class: "m-2 mt-4" }
const _hoisted_9 = { class: "m-2" }
const _hoisted_10 = { class: "text-muted m-2" }
const _hoisted_11 = { class: "m-4" }
const _hoisted_12 = { class: "d-flex justify-content-center m-3" }
const _hoisted_13 = ["id", "href"]
const _hoisted_14 = { class: "row row-cols-1 row-cols-md-2 row-cols-xl-3 g-3 mx-2" }
const _hoisted_15 = ["href"]
const _hoisted_16 = ["id", "src"]
const _hoisted_17 = { class: "d-flex justify-content-center m-3 mt-5" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-grid-fill me-2",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3z" })
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Go Back", -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.result)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Loading... "))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.result.launch.mission_name), 1),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.result.launch.links.mission_patch)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  id: _ctx.result.launch.links.mission_patch,
                  src: _ctx.result.launch.links.mission_patch,
                  alt: "mission patch",
                  class: "h-25 w-25 m-3"
                }, null, 8, _hoisted_6))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  id: _ctx.result.launch.links.flickr_images[0],
                  src: _ctx.result.launch.links.flickr_images[0],
                  alt: "mission photo",
                  class: "h-25 w-25 m-3"
                }, null, 8, _hoisted_7)),
            _createElementVNode("h6", _hoisted_8, "Rocket: " + _toDisplayString(_ctx.result.launch.rocket.rocket_name), 1),
            _createElementVNode("h6", _hoisted_9, " Launch site: " + _toDisplayString(_ctx.result.launch.launch_site.site_name_long), 1),
            _createElementVNode("h6", _hoisted_10, " Launch date: " + _toDisplayString(_ctx.convertDate(_ctx.result.launch.launch_date_utc)), 1)
          ]),
          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.result.launch.details), 1),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("a", {
              id: _ctx.result.launch.links.wikipedia,
              href: _ctx.result.launch.links.wikipedia
            }, "Wikipedia Link", 8, _hoisted_13)
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result.launch.links.flickr_images, (image) => {
              return (_openBlock(), _createElementBlock("div", {
                key: image,
                class: "d-flex justify-content-center align-items-center g-md-3 g-2"
              }, [
                _createElementVNode("a", {
                  href: image,
                  target: "_blank"
                }, [
                  _createElementVNode("img", {
                    id: image,
                    src: image,
                    alt: "flickr image",
                    style: {"width":"30vh","object-fit":"contain"}
                  }, null, 8, _hoisted_16)
                ], 8, _hoisted_15)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", {
              class: "btn btn-primary btn-lg mb-5 d-flex align-items-center",
              onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.toMissions && _ctx.toMissions(...args)))
            }, _hoisted_20)
          ])
        ]))
  ]))
};

defaultExport.render = render;

export default defaultExport;